import { Plan } from '../types'

export const mockClassicPlan: Plan = {
  id: 'SM_30GB',
  transactionId: '28758',
  expiry: '2021-11-10T15:32:28.667+0000',
  slug: '30gb-data',
  description: '30GB Data, Unlimited Text, Unlimited Voice',
  name: '30GB',
  originalPrice: {
    value: 10,
    currency: 'GBP',
  },
  finalPrice: {
    value: 0,
    currency: 'GBP',
  },
  finalPriceWithoutCredit: {
    value: 9,
    currency: 'GBP',
  },
  renewalDate: '2021-09-20T00:00:00.000+0100',
  dataAllowanceKB: 31457280,
  dataAllowanceGB: 30,
  dataAllowancePromosOnlyGB: null,
  dataAllowanceWithPromosGB: 30,
  voiceAllowance: null,
  smsAllowance: null,
  remainingDataAllowanceKB: null,
  remainingDataAllowanceGB: 0,
  remainingVoiceAllowance: null,
  remainingSmsAllowance: null,
  usedDataDiscount: null,
  planHasDataDiscount: false,
  availableDataDiscount: null,
  usedAccountBalance: {
    value: 9,
    currency: 'GBP',
  },
  planIsDataOnly: false,
  availableAccountBalance: {
    value: 15,
    currency: 'GBP',
  },
  groups: {
    groupDiscountPercentage: 10,
    groupDiscountValue: {
      value: 1,
      currency: 'GBP',
    },
  },
  referrals: {
    referralCreditsUsed: false,
    referralCreditsAvailable: 0,
    referralDiscount: null,
  },
  voucher: null,
  planIsSocialTariff: false,
}

export const mockClassicPlans: Plan[] = [
  {
    id: 'SM_30GB',
    transactionId: '28758',
    expiry: '2021-11-10T15:32:28.667+0000',
    slug: '30gb-data',
    description: '30GB Data, Unlimited Text, Unlimited Voice',
    name: '30GB',
    originalPrice: {
      value: 10,
      currency: 'GBP',
    },
    finalPrice: {
      value: 0,
      currency: 'GBP',
    },
    finalPriceWithoutCredit: {
      value: 9,
      currency: 'GBP',
    },
    renewalDate: '2021-09-20T00:00:00.000+0100',
    dataAllowanceKB: 31457280,
    dataAllowanceGB: 30,
    dataAllowancePromosOnlyGB: null,
    dataAllowanceWithPromosGB: 30,
    voiceAllowance: null,
    smsAllowance: null,
    remainingDataAllowanceKB: null,
    remainingDataAllowanceGB: 0,
    remainingVoiceAllowance: null,
    remainingSmsAllowance: null,
    usedDataDiscount: null,
    planHasDataDiscount: false,
    availableDataDiscount: null,
    usedAccountBalance: {
      value: 9,
      currency: 'GBP',
    },
    planIsDataOnly: false,
    availableAccountBalance: {
      value: 15,
      currency: 'GBP',
    },
    groups: {
      groupDiscountPercentage: 10,
      groupDiscountValue: {
        value: 1,
        currency: 'GBP',
      },
    },
    referrals: {
      referralCreditsUsed: false,
      referralCreditsAvailable: 0,
      referralDiscount: null,
    },
    voucher: {
      code: 'TestVoucher30GBDD2',
      title: 'test voucher 2',
      plan_card_heading: 'Test voucher for Luka',
      accordion_heading: 'Test voucher 2',
      is_default: true,
      is_free_trial_voucher: false,
      valid_from: '2021-05-11T00:00+00:00',
      valid_to: '2021-10-25T23:59+00:00',
      data_amount: 30,
      billing_line_items: [
        {
          id: '30GB double data',
          label: 'Offer',
          value: 'FREE',
          add_background_highlight: false,
        },
      ],
      offer_details: 'Double data Offer for testing only',
      offer_chip_text: 'DOUBLE DATA',
      roundel_type: 'double-data',
      terms_and_conditions_url:
        'https://cdn.smarty.co.uk/files/smarty-promo-25Off30GBFeb21AFF.pdf',
    },
    planIsSocialTariff: false,
  },
  {
    id: 'SM_50GB',
    transactionId: '28758',
    expiry: '2021-11-10T15:32:28.667+0000',
    slug: '50gb-data',
    description: '50GB Data, Unlimited Text, Unlimited Voice',
    name: '50GB',
    originalPrice: {
      value: 15,
      currency: 'GBP',
    },
    finalPrice: {
      value: 0,
      currency: 'GBP',
    },
    finalPriceWithoutCredit: {
      value: 13.5,
      currency: 'GBP',
    },
    renewalDate: '2021-09-20T00:00:00.000+0100',
    dataAllowanceKB: 52428800,
    dataAllowanceGB: 50,
    dataAllowancePromosOnlyGB: null,
    dataAllowanceWithPromosGB: 50,
    voiceAllowance: null,
    smsAllowance: null,
    remainingDataAllowanceKB: null,
    remainingDataAllowanceGB: 0,
    remainingVoiceAllowance: null,
    remainingSmsAllowance: null,
    usedDataDiscount: null,
    planHasDataDiscount: false,
    availableDataDiscount: null,
    usedAccountBalance: {
      value: 13.5,
      currency: 'GBP',
    },
    planIsDataOnly: false,
    availableAccountBalance: {
      value: 15,
      currency: 'GBP',
    },
    groups: {
      groupDiscountPercentage: 10,
      groupDiscountValue: {
        value: 1.5,
        currency: 'GBP',
      },
    },
    referrals: {
      referralCreditsUsed: false,
      referralCreditsAvailable: 0,
      referralDiscount: null,
    },
    voucher: null,
    planIsSocialTariff: false,
  },
  {
    id: 'SM_12GB_NDD',
    transactionId: '28758',
    expiry: '2021-11-10T15:32:28.667+0000',
    slug: '12gb-data',
    description: '12GB Data, Unlimited Text, Unlimited Voice',
    name: '12-GB',
    originalPrice: {
      value: 8,
      currency: 'GBP',
    },
    finalPrice: {
      value: 0,
      currency: 'GBP',
    },
    finalPriceWithoutCredit: {
      value: 7.2,
      currency: 'GBP',
    },
    renewalDate: '2021-09-20T00:00:00.000+0100',
    dataAllowanceKB: 12582912,
    dataAllowanceGB: 12,
    dataAllowancePromosOnlyGB: null,
    dataAllowanceWithPromosGB: 12,
    voiceAllowance: null,
    smsAllowance: null,
    remainingDataAllowanceKB: null,
    remainingDataAllowanceGB: 0,
    remainingVoiceAllowance: null,
    remainingSmsAllowance: null,
    usedDataDiscount: null,
    planHasDataDiscount: false,
    availableDataDiscount: null,
    usedAccountBalance: {
      value: 7.2,
      currency: 'GBP',
    },
    planIsDataOnly: false,
    availableAccountBalance: {
      value: 15,
      currency: 'GBP',
    },
    groups: {
      groupDiscountPercentage: 10,
      groupDiscountValue: {
        value: 0.8,
        currency: 'GBP',
      },
    },
    referrals: {
      referralCreditsUsed: false,
      referralCreditsAvailable: 0,
      referralDiscount: null,
    },
    voucher: null,
    planIsSocialTariff: false,
  },
  {
    id: 'SM_4GB_NDD',
    transactionId: '28758',
    expiry: '2021-11-10T15:32:28.667+0000',
    slug: '4gb-data',
    description: '4GB Data, Unlimited Text, Unlimited Voice',
    name: '4-GB',
    originalPrice: {
      value: 6,
      currency: 'GBP',
    },
    finalPrice: {
      value: 0,
      currency: 'GBP',
    },
    finalPriceWithoutCredit: {
      value: 5.4,
      currency: 'GBP',
    },
    renewalDate: '2021-09-20T00:00:00.000+0100',
    dataAllowanceKB: 4194304,
    dataAllowanceGB: 4,
    dataAllowancePromosOnlyGB: null,
    dataAllowanceWithPromosGB: 4,
    voiceAllowance: null,
    smsAllowance: null,
    remainingDataAllowanceKB: null,
    remainingDataAllowanceGB: 0,
    remainingVoiceAllowance: null,
    remainingSmsAllowance: null,
    usedDataDiscount: null,
    planHasDataDiscount: false,
    availableDataDiscount: null,
    usedAccountBalance: {
      value: 5.4,
      currency: 'GBP',
    },
    planIsDataOnly: false,
    availableAccountBalance: {
      value: 15,
      currency: 'GBP',
    },
    groups: {
      groupDiscountPercentage: 10,
      groupDiscountValue: {
        value: 0.6,
        currency: 'GBP',
      },
    },
    referrals: {
      referralCreditsUsed: false,
      referralCreditsAvailable: 0,
      referralDiscount: null,
    },
    voucher: null,
    planIsSocialTariff: false,
  },
  {
    id: 'SM_8GB_NDD',
    transactionId: '28758',
    expiry: '2021-11-10T15:32:28.667+0000',
    slug: '8gb-data',
    description: '8GB Data, Unlimited Text, Unlimited Voice',
    name: '8-GB',
    originalPrice: {
      value: 7,
      currency: 'GBP',
    },
    finalPrice: {
      value: 0,
      currency: 'GBP',
    },
    finalPriceWithoutCredit: {
      value: 6.3,
      currency: 'GBP',
    },
    renewalDate: '2021-09-20T00:00:00.000+0100',
    dataAllowanceKB: 8388608,
    dataAllowanceGB: 8,
    dataAllowancePromosOnlyGB: null,
    dataAllowanceWithPromosGB: 8,
    voiceAllowance: null,
    smsAllowance: null,
    remainingDataAllowanceKB: null,
    remainingDataAllowanceGB: 0,
    remainingVoiceAllowance: null,
    remainingSmsAllowance: null,
    usedDataDiscount: null,
    planHasDataDiscount: false,
    availableDataDiscount: null,
    usedAccountBalance: {
      value: 6.3,
      currency: 'GBP',
    },
    planIsDataOnly: false,
    availableAccountBalance: {
      value: 15,
      currency: 'GBP',
    },
    groups: {
      groupDiscountPercentage: 10,
      groupDiscountValue: {
        value: 0.7,
        currency: 'GBP',
      },
    },
    referrals: {
      referralCreditsUsed: false,
      referralCreditsAvailable: 0,
      referralDiscount: null,
    },
    voucher: null,
    planIsSocialTariff: false,
  },
  {
    id: 'SM_UNLIMITED',
    transactionId: '28758',
    expiry: '2021-11-10T15:32:28.667+0000',
    slug: 'unlimited',
    description: 'Unlimited Data, Unlimited Text, Unlimited Voice',
    name: 'Unlimited',
    originalPrice: {
      value: 20,
      currency: 'GBP',
    },
    finalPrice: {
      value: 3,
      currency: 'GBP',
    },
    finalPriceWithoutCredit: {
      value: 18,
      currency: 'GBP',
    },
    renewalDate: '2021-09-20T00:00:00.000+0100',
    dataAllowanceKB: null,
    dataAllowanceGB: 0,
    dataAllowancePromosOnlyGB: null,
    dataAllowanceWithPromosGB: 0,
    voiceAllowance: null,
    smsAllowance: null,
    remainingDataAllowanceKB: null,
    remainingDataAllowanceGB: 0,
    remainingVoiceAllowance: null,
    remainingSmsAllowance: null,
    usedDataDiscount: null,
    planHasDataDiscount: false,
    availableDataDiscount: null,
    usedAccountBalance: {
      value: 15,
      currency: 'GBP',
    },
    planIsDataOnly: false,
    availableAccountBalance: {
      value: 15,
      currency: 'GBP',
    },
    groups: {
      groupDiscountPercentage: 10,
      groupDiscountValue: {
        value: 2,
        currency: 'GBP',
      },
    },
    referrals: {
      referralCreditsUsed: false,
      referralCreditsAvailable: 0,
      referralDiscount: null,
    },
    voucher: null,
    planIsSocialTariff: false,
  },
]

export const mockDataDiscountPlan: Plan = {
  id: 'SM_SMALL',
  transactionId: '28758',
  expiry: '2021-11-10T15:32:28.667+0000',
  slug: '2gb-data',
  description: '2GB Data, Unlimited Text, Unlimited Voice',
  name: '2GB',
  originalPrice: {
    value: 7,
    currency: 'GBP',
  },
  finalPrice: {
    value: 0,
    currency: 'GBP',
  },
  finalPriceWithoutCredit: {
    value: 6.3,
    currency: 'GBP',
  },
  renewalDate: '2021-09-20T00:00:00.000+0100',
  dataAllowanceKB: 2097152,
  dataAllowanceGB: 2,
  dataAllowancePromosOnlyGB: null,
  dataAllowanceWithPromosGB: 2,
  voiceAllowance: null,
  smsAllowance: null,
  remainingDataAllowanceKB: null,
  remainingDataAllowanceGB: 0,
  remainingVoiceAllowance: null,
  remainingSmsAllowance: null,
  usedDataDiscount: null,
  planHasDataDiscount: true,
  availableDataDiscount: null,
  usedAccountBalance: {
    value: 6.3,
    currency: 'GBP',
  },
  planIsDataOnly: false,
  availableAccountBalance: {
    value: 15,
    currency: 'GBP',
  },
  groups: {
    groupDiscountPercentage: 10,
    groupDiscountValue: {
      value: 0.7,
      currency: 'GBP',
    },
  },
  referrals: {
    referralCreditsUsed: false,
    referralCreditsAvailable: 0,
    referralDiscount: null,
  },
  voucher: null,
  planIsSocialTariff: false,
}

export const mockDataDiscountPlans: Plan[] = [
  {
    id: 'SM_SMALL',
    transactionId: '28758',
    expiry: '2021-11-10T15:32:28.667+0000',
    slug: '2gb-data',
    description: '2GB Data, Unlimited Text, Unlimited Voice',
    name: '2GB',
    originalPrice: {
      value: 7,
      currency: 'GBP',
    },
    finalPrice: {
      value: 0,
      currency: 'GBP',
    },
    finalPriceWithoutCredit: {
      value: 6.3,
      currency: 'GBP',
    },
    renewalDate: '2021-09-20T00:00:00.000+0100',
    dataAllowanceKB: 2097152,
    dataAllowanceGB: 2,
    dataAllowancePromosOnlyGB: null,
    dataAllowanceWithPromosGB: 2,
    voiceAllowance: null,
    smsAllowance: null,
    remainingDataAllowanceKB: null,
    remainingDataAllowanceGB: 0,
    remainingVoiceAllowance: null,
    remainingSmsAllowance: null,
    usedDataDiscount: null,
    planHasDataDiscount: true,
    availableDataDiscount: null,
    usedAccountBalance: {
      value: 6.3,
      currency: 'GBP',
    },
    planIsDataOnly: false,
    availableAccountBalance: {
      value: 15,
      currency: 'GBP',
    },
    groups: {
      groupDiscountPercentage: 10,
      groupDiscountValue: {
        value: 0.7,
        currency: 'GBP',
      },
    },
    referrals: {
      referralCreditsUsed: false,
      referralCreditsAvailable: 0,
      referralDiscount: null,
    },
    voucher: null,
    planIsSocialTariff: false,
  },
  {
    id: 'SM_EXTRASMALL',
    transactionId: '28758',
    expiry: '2021-11-10T15:32:28.667+0000',
    slug: '1gb-data',
    description: '1GB Data, Unlimited Text, Unlimited Voice',
    name: '1GB',
    originalPrice: {
      value: 6,
      currency: 'GBP',
    },
    finalPrice: {
      value: 0,
      currency: 'GBP',
    },
    finalPriceWithoutCredit: {
      value: 5.4,
      currency: 'GBP',
    },
    renewalDate: '2021-09-20T00:00:00.000+0100',
    dataAllowanceKB: 1048576,
    dataAllowanceGB: 1,
    dataAllowancePromosOnlyGB: null,
    dataAllowanceWithPromosGB: 1,
    voiceAllowance: null,
    smsAllowance: null,
    remainingDataAllowanceKB: null,
    remainingDataAllowanceGB: 0,
    remainingVoiceAllowance: null,
    remainingSmsAllowance: null,
    usedDataDiscount: null,
    planHasDataDiscount: true,
    availableDataDiscount: null,
    usedAccountBalance: {
      value: 5.4,
      currency: 'GBP',
    },
    planIsDataOnly: false,
    availableAccountBalance: {
      value: 15,
      currency: 'GBP',
    },
    groups: {
      groupDiscountPercentage: 10,
      groupDiscountValue: {
        value: 0.6,
        currency: 'GBP',
      },
    },
    referrals: {
      referralCreditsUsed: false,
      referralCreditsAvailable: 0,
      referralDiscount: null,
    },
    voucher: null,
    planIsSocialTariff: false,
  },
  {
    id: 'SM_3GB',
    transactionId: '28758',
    expiry: '2021-11-10T15:32:28.667+0000',
    slug: '3gb-data',
    description: '3GB Data, Unlimited Text, Unlimited Voice',
    name: '3GB',
    originalPrice: {
      value: 8,
      currency: 'GBP',
    },
    finalPrice: {
      value: 0,
      currency: 'GBP',
    },
    finalPriceWithoutCredit: {
      value: 7.2,
      currency: 'GBP',
    },
    renewalDate: '2021-09-20T00:00:00.000+0100',
    dataAllowanceKB: 3145728,
    dataAllowanceGB: 3,
    dataAllowancePromosOnlyGB: null,
    dataAllowanceWithPromosGB: 3,
    voiceAllowance: null,
    smsAllowance: null,
    remainingDataAllowanceKB: null,
    remainingDataAllowanceGB: 0,
    remainingVoiceAllowance: null,
    remainingSmsAllowance: null,
    usedDataDiscount: null,
    planHasDataDiscount: true,
    availableDataDiscount: null,
    usedAccountBalance: {
      value: 7.2,
      currency: 'GBP',
    },
    planIsDataOnly: false,
    availableAccountBalance: {
      value: 15,
      currency: 'GBP',
    },
    groups: {
      groupDiscountPercentage: 10,
      groupDiscountValue: {
        value: 0.8,
        currency: 'GBP',
      },
    },
    referrals: {
      referralCreditsUsed: false,
      referralCreditsAvailable: 0,
      referralDiscount: null,
    },
    voucher: null,
    planIsSocialTariff: false,
  },
]

export const mockDataOnlyPlan: Plan = {
  id: 'SM_2GB_DATAONLY',
  transactionId: '28758',
  expiry: '2021-11-10T15:32:28.667+0000',
  slug: '2gb-data-only',
  description: '2GB Data',
  name: '2GB_DATAONLY',
  categoryName: 'Data only',
  originalPrice: {
    value: 5,
    currency: 'GBP',
  },
  finalPrice: {
    value: 0,
    currency: 'GBP',
  },
  finalPriceWithoutCredit: {
    value: 4.5,
    currency: 'GBP',
  },
  renewalDate: '2021-09-20T00:00:00.000+0100',
  dataAllowanceKB: 2097152,
  dataAllowanceGB: 2,
  dataAllowancePromosOnlyGB: null,
  dataAllowanceWithPromosGB: 2,
  voiceAllowance: 0,
  smsAllowance: 0,
  remainingDataAllowanceKB: null,
  remainingDataAllowanceGB: 0,
  remainingVoiceAllowance: null,
  remainingSmsAllowance: null,
  usedDataDiscount: null,
  planHasDataDiscount: false,
  availableDataDiscount: null,
  usedAccountBalance: {
    value: 4.5,
    currency: 'GBP',
  },
  planIsDataOnly: true,
  availableAccountBalance: {
    value: 15,
    currency: 'GBP',
  },
  groups: {
    groupDiscountPercentage: 10,
    groupDiscountValue: {
      value: 0.5,
      currency: 'GBP',
    },
  },
  referrals: {
    referralCreditsUsed: false,
    referralCreditsAvailable: 0,
    referralDiscount: null,
  },
  voucher: null,
  planIsSocialTariff: false,
}

export const mockDataOnlyPlans: Plan[] = [
  {
    id: 'SM_2GB_DATAONLY',
    transactionId: '28758',
    expiry: '2021-11-10T15:32:28.667+0000',
    slug: '2gb-data-only',
    description: '2GB Data',
    name: '2GB_DATAONLY',
    categoryName: 'Data only',
    originalPrice: {
      value: 5,
      currency: 'GBP',
    },
    finalPrice: {
      value: 0,
      currency: 'GBP',
    },
    finalPriceWithoutCredit: {
      value: 4.5,
      currency: 'GBP',
    },
    renewalDate: '2021-09-20T00:00:00.000+0100',
    dataAllowanceKB: 2097152,
    dataAllowanceGB: 2,
    dataAllowancePromosOnlyGB: null,
    dataAllowanceWithPromosGB: 2,
    voiceAllowance: 0,
    smsAllowance: 0,
    remainingDataAllowanceKB: null,
    remainingDataAllowanceGB: 0,
    remainingVoiceAllowance: null,
    remainingSmsAllowance: null,
    usedDataDiscount: null,
    planHasDataDiscount: false,
    availableDataDiscount: null,
    usedAccountBalance: {
      value: 4.5,
      currency: 'GBP',
    },
    planIsDataOnly: true,
    availableAccountBalance: {
      value: 15,
      currency: 'GBP',
    },
    groups: {
      groupDiscountPercentage: 10,
      groupDiscountValue: {
        value: 0.5,
        currency: 'GBP',
      },
    },
    referrals: {
      referralCreditsUsed: false,
      referralCreditsAvailable: 0,
      referralDiscount: null,
    },
    voucher: null,
    planIsSocialTariff: false,
  },
  {
    id: 'SM_15GB_DATAONLY',
    transactionId: '28758',
    expiry: '2021-11-10T15:32:28.667+0000',
    slug: '15gb-data-only',
    description: '15GB Data',
    name: '15GB_DATAONLY',
    categoryName: 'Data only',
    originalPrice: {
      value: 9,
      currency: 'GBP',
    },
    finalPrice: {
      value: 0,
      currency: 'GBP',
    },
    finalPriceWithoutCredit: {
      value: 8.1,
      currency: 'GBP',
    },
    renewalDate: '2021-09-20T00:00:00.000+0100',
    dataAllowanceKB: 15728640,
    dataAllowanceGB: 15,
    dataAllowancePromosOnlyGB: null,
    dataAllowanceWithPromosGB: 15,
    voiceAllowance: 0,
    smsAllowance: 0,
    remainingDataAllowanceKB: null,
    remainingDataAllowanceGB: 0,
    remainingVoiceAllowance: null,
    remainingSmsAllowance: null,
    usedDataDiscount: null,
    planHasDataDiscount: false,
    availableDataDiscount: null,
    usedAccountBalance: {
      value: 8.1,
      currency: 'GBP',
    },
    planIsDataOnly: true,
    availableAccountBalance: {
      value: 15,
      currency: 'GBP',
    },
    groups: {
      groupDiscountPercentage: 10,
      groupDiscountValue: {
        value: 0.9,
        currency: 'GBP',
      },
    },
    referrals: {
      referralCreditsUsed: false,
      referralCreditsAvailable: 0,
      referralDiscount: null,
    },
    voucher: null,
    planIsSocialTariff: false,
  },
]

export const mockCurrentOffers = [
  {
    id: 'SM_4GB_NDD',
    transactionId: null,
    expiry: null,
    slug: '4gb-data',
    description: '4GB Data, Unlimited Text, Unlimited Voice',
    name: '4GB',
    categoryName: 'Classic',
    categoryType: 'classic',
    style: {
      planColor: 'Brand/Yellow',
      planColorPale: 'Brand/PaleYellow',
    },
    originalPrice: { value: 6.0, currency: 'GBP' },
    finalPrice: { value: 6.0, currency: 'GBP' },
    finalPriceWithoutCredit: { value: 6.0, currency: 'GBP' },
    renewalDate: '2022-12-19T00:00:00.000+0000',
    dataAllowanceKB: 4194304,
    dataAllowanceGB: 4.0,
    dataAllowancePromosOnlyGB: 2.0,
    dataAllowanceWithPromosGB: 6.0,
    voiceAllowance: null,
    smsAllowance: null,
    remainingDataAllowanceKB: null,
    remainingDataAllowanceGB: 0.0,
    remainingVoiceAllowance: null,
    remainingSmsAllowance: null,
    usedDataDiscount: null,
    planHasDataDiscount: false,
    availableDataDiscount: null,
    usedAccountBalance: { value: 0.0, currency: 'GBP' },
    planIsDataOnly: false,
    availableAccountBalance: { value: 0.0, currency: 'GBP' },
    groups: {
      groupDiscountPercentage: 10,
      groupDiscountValue: { value: 0.0, currency: 'GBP' },
    },
    referrals: {
      referralCreditsUsed: false,
      referralCreditsAvailable: 0,
      referralDiscount: null,
    },
    voucher: {
      _sys_id: '6nHxzsgawPTGK3EEiGro1X',
      id: '6nHxzsgawPTGK3EEiGro1X',
      code: '15Mth6GB6Nov22NBO',
      title: '6GB for £6 NBO Black Friday Nov 22',
      plan_card_heading: 'Switch now and get 6GB for £6',
      accordion_heading: '6GB for just £6 ',
      is_default: false,
      is_default_hero_banner: false,
      is_free_trial_voucher: false,
      valid_from: '2022-11-01T00:00+01:00',
      valid_to: '2022-12-05T23:59+01:00',
      applies_to: {
        _sys_id: '5Kk0iDpzNyX9fcqugpm0w2',
        id: 'SM_4GB_NDD',
        category: {
          _sys_id: '57qk7RvuVDnEiVHo0c8cvF',
          id: '57qk7RvuVDnEiVHo0c8cvF',
        },
        plan_color: {
          _sys_id: '2Sfln8Vw0cgdck7p3McyOX',
          id: '2Sfln8Vw0cgdck7p3McyOX',
        },
        plan_color_pale: {
          _sys_id: '1XWdtz8mVFJ62WDPpkBEjE',
          id: '1XWdtz8mVFJ62WDPpkBEjE',
        },
        name: '4GB',
        description: '4GB Data, Unlimited Text, Unlimited Voice',
        slug: '4gb-data',
      },
      discounted_price: 6,
      data_amount: 6,
      billing_line_items: [
        {
          _sys_id: '54ALluFpe2sMxhfpwE3Jwe',
          id: '6GB for just £6',
          label: 'Offer',
          value: '6',
          add_background_highlight: true,
        },
      ],
      offer_details:
        "Switch now to get an additional 2GB of data. That's a total of 6GB for just £6 (usually 4GB for £6) for up to 15 consecutive months, that gives you until January 2024 on this amazing offer.",
      offer_chip_text: 'SPECIAL OFFER ',
      roundel_type: 'Extra Data',
      terms_and_conditions_url:
        'https://cdn.smarty.co.uk/files/smarty-promo-15Mth6GB6Nov22NBO.pdf',
      show_countdown: false,
      promoPercentageDiscount: null,
      promoDiscount: null,
      promoAddonCode: '2GB_PROMO_DATA_GWG',
      promoAddonDescription: 'Promo extra data add-on (2GB)',
      promoAddonLimit: 2097152,
      promoAddonUnit: 'KB',
      promoValidFrom: '2022-11-03T14:13:00.000+0000',
      promoValidTo: '2022-12-05T00:00:00.000+0000',
      promoMonthsRemaining: 15,
    },
    planIsSocialTariff: false,
  },
  {
    id: 'SM_50GB',
    transactionId: null,
    expiry: null,
    slug: '50gb-data',
    description: '50GB Data, Unlimited Text, Unlimited Voice',
    name: '50GB',
    categoryName: 'Classic',
    categoryType: 'classic',
    style: { planColor: 'Brand/Aqua', planColorPale: 'Brand/PaleAqua' },
    originalPrice: { value: 15.0, currency: 'GBP' },
    finalPrice: { value: 10.13, currency: 'GBP' },
    finalPriceWithoutCredit: { value: 10.13, currency: 'GBP' },
    renewalDate: '2022-12-19T00:00:00.000+0000',
    dataAllowanceKB: 52428800,
    dataAllowanceGB: 50.0,
    dataAllowancePromosOnlyGB: null,
    dataAllowanceWithPromosGB: 50.0,
    voiceAllowance: null,
    smsAllowance: null,
    remainingDataAllowanceKB: null,
    remainingDataAllowanceGB: 0.0,
    remainingVoiceAllowance: null,
    remainingSmsAllowance: null,
    usedDataDiscount: null,
    planHasDataDiscount: false,
    availableDataDiscount: null,
    usedAccountBalance: { value: 0.0, currency: 'GBP' },
    planIsDataOnly: false,
    availableAccountBalance: { value: 0.0, currency: 'GBP' },
    groups: {
      groupDiscountPercentage: 10,
      groupDiscountValue: { value: 1.12, currency: 'GBP' },
    },
    referrals: {
      referralCreditsUsed: false,
      referralCreditsAvailable: 0,
      referralDiscount: null,
    },
    voucher: null,
    planIsSocialTariff: false,
  },
  {
    id: 'SM_50GB',
    transactionId: null,
    expiry: null,
    slug: '50gb-data',
    description: '50GB Data, Unlimited Text, Unlimited Voice',
    name: '50GB',
    categoryName: 'Classic',
    categoryType: 'classic',
    style: { planColor: 'Brand/Aqua', planColorPale: 'Brand/PaleAqua' },
    originalPrice: { value: 15.0, currency: 'GBP' },
    finalPrice: { value: 9.0, currency: 'GBP' },
    finalPriceWithoutCredit: { value: 9.0, currency: 'GBP' },
    renewalDate: '2022-12-19T00:00:00.000+0000',
    dataAllowanceKB: 52428800,
    dataAllowanceGB: 50.0,
    dataAllowancePromosOnlyGB: null,
    dataAllowanceWithPromosGB: 50.0,
    voiceAllowance: null,
    smsAllowance: null,
    remainingDataAllowanceKB: null,
    remainingDataAllowanceGB: 0.0,
    remainingVoiceAllowance: null,
    remainingSmsAllowance: null,
    usedDataDiscount: null,
    planHasDataDiscount: false,
    availableDataDiscount: null,
    usedAccountBalance: { value: 0.0, currency: 'GBP' },
    planIsDataOnly: false,
    availableAccountBalance: { value: 0.0, currency: 'GBP' },
    groups: {
      groupDiscountPercentage: 10,
      groupDiscountValue: { value: 1.0, currency: 'GBP' },
    },
    referrals: {
      referralCreditsUsed: false,
      referralCreditsAvailable: 0,
      referralDiscount: null,
    },
    voucher: null,
    planIsSocialTariff: false,
  },
  {
    id: 'SM_50GB',
    transactionId: null,
    expiry: null,
    slug: '50gb-data',
    description: '50GB Data, Unlimited Text, Unlimited Voice',
    name: '50GB',
    categoryName: 'Classic',
    categoryType: 'classic',
    style: { planColor: 'Brand/Aqua', planColorPale: 'Brand/PaleAqua' },
    originalPrice: { value: 15.0, currency: 'GBP' },
    finalPrice: { value: 4.5, currency: 'GBP' },
    finalPriceWithoutCredit: { value: 4.5, currency: 'GBP' },
    renewalDate: '2022-12-19T00:00:00.000+0000',
    dataAllowanceKB: 52428800,
    dataAllowanceGB: 50.0,
    dataAllowancePromosOnlyGB: null,
    dataAllowanceWithPromosGB: 50.0,
    voiceAllowance: null,
    smsAllowance: null,
    remainingDataAllowanceKB: null,
    remainingDataAllowanceGB: 0.0,
    remainingVoiceAllowance: null,
    remainingSmsAllowance: null,
    usedDataDiscount: null,
    planHasDataDiscount: false,
    availableDataDiscount: null,
    usedAccountBalance: { value: 0.0, currency: 'GBP' },
    planIsDataOnly: false,
    availableAccountBalance: { value: 0.0, currency: 'GBP' },
    groups: {
      groupDiscountPercentage: 10,
      groupDiscountValue: { value: 0.5, currency: 'GBP' },
    },
    referrals: {
      referralCreditsUsed: false,
      referralCreditsAvailable: 0,
      referralDiscount: null,
    },
    voucher: null,
    planIsSocialTariff: false,
  },
  {
    id: 'SM_30GB',
    transactionId: null,
    expiry: null,
    slug: '30gb-data',
    description: '30GB Data, Unlimited Text, Unlimited Voice',
    name: '30GB',
    categoryName: 'Classic',
    categoryType: 'classic',
    style: {
      planColor: 'Brand/Orange',
      planColorPale: 'Brand/PaleOrange',
    },
    originalPrice: { value: 10.0, currency: 'GBP' },
    finalPrice: { value: 6.75, currency: 'GBP' },
    finalPriceWithoutCredit: { value: 6.75, currency: 'GBP' },
    renewalDate: '2022-12-19T00:00:00.000+0000',
    dataAllowanceKB: 31457280,
    dataAllowanceGB: 30.0,
    dataAllowancePromosOnlyGB: null,
    dataAllowanceWithPromosGB: 30.0,
    voiceAllowance: null,
    smsAllowance: null,
    remainingDataAllowanceKB: null,
    remainingDataAllowanceGB: 0.0,
    remainingVoiceAllowance: null,
    remainingSmsAllowance: null,
    usedDataDiscount: null,
    planHasDataDiscount: false,
    availableDataDiscount: null,
    usedAccountBalance: { value: 0.0, currency: 'GBP' },
    planIsDataOnly: false,
    availableAccountBalance: { value: 0.0, currency: 'GBP' },
    groups: {
      groupDiscountPercentage: 10,
      groupDiscountValue: { value: 0.75, currency: 'GBP' },
    },
    referrals: {
      referralCreditsUsed: false,
      referralCreditsAvailable: 0,
      referralDiscount: null,
    },
    voucher: null,
    planIsSocialTariff: false,
  },
  {
    id: 'SM_30GB',
    transactionId: null,
    expiry: null,
    slug: '30gb-data',
    description: '30GB Data, Unlimited Text, Unlimited Voice',
    name: '30GB',
    categoryName: 'Classic',
    categoryType: 'classic',
    style: {
      planColor: 'Brand/Orange',
      planColorPale: 'Brand/PaleOrange',
    },
    originalPrice: { value: 10.0, currency: 'GBP' },
    finalPrice: { value: 4.5, currency: 'GBP' },
    finalPriceWithoutCredit: { value: 4.5, currency: 'GBP' },
    renewalDate: '2022-12-19T00:00:00.000+0000',
    dataAllowanceKB: 31457280,
    dataAllowanceGB: 30.0,
    dataAllowancePromosOnlyGB: null,
    dataAllowanceWithPromosGB: 30.0,
    voiceAllowance: null,
    smsAllowance: null,
    remainingDataAllowanceKB: null,
    remainingDataAllowanceGB: 0.0,
    remainingVoiceAllowance: null,
    remainingSmsAllowance: null,
    usedDataDiscount: null,
    planHasDataDiscount: false,
    availableDataDiscount: null,
    usedAccountBalance: { value: 0.0, currency: 'GBP' },
    planIsDataOnly: false,
    availableAccountBalance: { value: 0.0, currency: 'GBP' },
    groups: {
      groupDiscountPercentage: 10,
      groupDiscountValue: { value: 0.5, currency: 'GBP' },
    },
    referrals: {
      referralCreditsUsed: false,
      referralCreditsAvailable: 0,
      referralDiscount: null,
    },
    voucher: null,
    planIsSocialTariff: false,
  },
  {
    id: 'SM_30GB',
    transactionId: null,
    expiry: null,
    slug: '30gb-data',
    description: '30GB Data, Unlimited Text, Unlimited Voice',
    name: '30GB',
    categoryName: 'Classic',
    categoryType: 'classic',
    style: {
      planColor: 'Brand/Orange',
      planColorPale: 'Brand/PaleOrange',
    },
    originalPrice: { value: 10.0, currency: 'GBP' },
    finalPrice: { value: 4.5, currency: 'GBP' },
    finalPriceWithoutCredit: { value: 4.5, currency: 'GBP' },
    renewalDate: '2022-12-19T00:00:00.000+0000',
    dataAllowanceKB: 31457280,
    dataAllowanceGB: 30.0,
    dataAllowancePromosOnlyGB: null,
    dataAllowanceWithPromosGB: 30.0,
    voiceAllowance: null,
    smsAllowance: null,
    remainingDataAllowanceKB: null,
    remainingDataAllowanceGB: 0.0,
    remainingVoiceAllowance: null,
    remainingSmsAllowance: null,
    usedDataDiscount: null,
    planHasDataDiscount: false,
    availableDataDiscount: null,
    usedAccountBalance: { value: 0.0, currency: 'GBP' },
    planIsDataOnly: false,
    availableAccountBalance: { value: 0.0, currency: 'GBP' },
    groups: {
      groupDiscountPercentage: 10,
      groupDiscountValue: { value: 0.5, currency: 'GBP' },
    },
    referrals: {
      referralCreditsUsed: false,
      referralCreditsAvailable: 0,
      referralDiscount: null,
    },
    voucher: null,
    planIsSocialTariff: false,
  },
  {
    id: 'SM_UNLIMITED',
    transactionId: null,
    expiry: null,
    slug: 'unlimited',
    description: 'Unlimited Data, Unlimited Text, Unlimited Voice',
    name: 'Unlimited',
    categoryName: 'Classic',
    categoryType: 'classic',
    style: {
      planColor: 'Brand/Purple',
      planColorPale: 'Brand/PalePurple',
    },
    originalPrice: { value: 20.0, currency: 'GBP' },
    finalPrice: { value: 13.5, currency: 'GBP' },
    finalPriceWithoutCredit: { value: 13.5, currency: 'GBP' },
    renewalDate: '2022-12-19T00:00:00.000+0000',
    dataAllowanceKB: null,
    dataAllowanceGB: 0.0,
    dataAllowancePromosOnlyGB: null,
    dataAllowanceWithPromosGB: 0.0,
    voiceAllowance: null,
    smsAllowance: null,
    remainingDataAllowanceKB: null,
    remainingDataAllowanceGB: 0.0,
    remainingVoiceAllowance: null,
    remainingSmsAllowance: null,
    usedDataDiscount: null,
    planHasDataDiscount: false,
    availableDataDiscount: null,
    usedAccountBalance: { value: 0.0, currency: 'GBP' },
    planIsDataOnly: false,
    availableAccountBalance: { value: 0.0, currency: 'GBP' },
    groups: {
      groupDiscountPercentage: 10,
      groupDiscountValue: { value: 1.5, currency: 'GBP' },
    },
    referrals: {
      referralCreditsUsed: false,
      referralCreditsAvailable: 0,
      referralDiscount: null,
    },
    voucher: null,
    planIsSocialTariff: false,
  },
  {
    id: 'SM_UNLIMITED',
    transactionId: null,
    expiry: null,
    slug: 'unlimited',
    description: 'Unlimited Data, Unlimited Text, Unlimited Voice',
    name: 'Unlimited',
    categoryName: 'Classic',
    categoryType: 'classic',
    style: {
      planColor: 'Brand/Purple',
      planColorPale: 'Brand/PalePurple',
    },
    originalPrice: { value: 20.0, currency: 'GBP' },
    finalPrice: { value: 13.5, currency: 'GBP' },
    finalPriceWithoutCredit: { value: 13.5, currency: 'GBP' },
    renewalDate: '2022-12-19T00:00:00.000+0000',
    dataAllowanceKB: null,
    dataAllowanceGB: 0.0,
    dataAllowancePromosOnlyGB: null,
    dataAllowanceWithPromosGB: 0.0,
    voiceAllowance: null,
    smsAllowance: null,
    remainingDataAllowanceKB: null,
    remainingDataAllowanceGB: 0.0,
    remainingVoiceAllowance: null,
    remainingSmsAllowance: null,
    usedDataDiscount: null,
    planHasDataDiscount: false,
    availableDataDiscount: null,
    usedAccountBalance: { value: 0.0, currency: 'GBP' },
    planIsDataOnly: false,
    availableAccountBalance: { value: 0.0, currency: 'GBP' },
    groups: {
      groupDiscountPercentage: 10,
      groupDiscountValue: { value: 1.5, currency: 'GBP' },
    },
    referrals: {
      referralCreditsUsed: false,
      referralCreditsAvailable: 0,
      referralDiscount: null,
    },
    voucher: null,
    planIsSocialTariff: false,
  },
  {
    id: 'SM_UNLIMITED',
    transactionId: null,
    expiry: null,
    slug: 'unlimited',
    description: 'Unlimited Data, Unlimited Text, Unlimited Voice',
    name: 'Unlimited',
    categoryName: 'Classic',
    categoryType: 'classic',
    style: {
      planColor: 'Brand/Purple',
      planColorPale: 'Brand/PalePurple',
    },
    originalPrice: { value: 20.0, currency: 'GBP' },
    finalPrice: { value: 4.5, currency: 'GBP' },
    finalPriceWithoutCredit: { value: 4.5, currency: 'GBP' },
    renewalDate: '2022-12-19T00:00:00.000+0000',
    dataAllowanceKB: null,
    dataAllowanceGB: 0.0,
    dataAllowancePromosOnlyGB: null,
    dataAllowanceWithPromosGB: 0.0,
    voiceAllowance: null,
    smsAllowance: null,
    remainingDataAllowanceKB: null,
    remainingDataAllowanceGB: 0.0,
    remainingVoiceAllowance: null,
    remainingSmsAllowance: null,
    usedDataDiscount: null,
    planHasDataDiscount: false,
    availableDataDiscount: null,
    usedAccountBalance: { value: 0.0, currency: 'GBP' },
    planIsDataOnly: false,
    availableAccountBalance: { value: 0.0, currency: 'GBP' },
    groups: {
      groupDiscountPercentage: 10,
      groupDiscountValue: { value: 0.5, currency: 'GBP' },
    },
    referrals: {
      referralCreditsUsed: false,
      referralCreditsAvailable: 0,
      referralDiscount: null,
    },
    voucher: null,
    planIsSocialTariff: false,
  },
  {
    id: 'SM_4GB_NDD',
    transactionId: null,
    expiry: null,
    slug: '4gb-data',
    description: '4GB Data, Unlimited Text, Unlimited Voice',
    name: '4GB',
    categoryName: 'Classic',
    categoryType: 'classic',
    style: {
      planColor: 'Brand/Yellow',
      planColorPale: 'Brand/PaleYellow',
    },
    originalPrice: { value: 6.0, currency: 'GBP' },
    finalPrice: { value: 6.0, currency: 'GBP' },
    finalPriceWithoutCredit: { value: 6.0, currency: 'GBP' },
    renewalDate: '2022-12-19T00:00:00.000+0000',
    dataAllowanceKB: 4194304,
    dataAllowanceGB: 4.0,
    dataAllowancePromosOnlyGB: 2.0,
    dataAllowanceWithPromosGB: 6.0,
    voiceAllowance: null,
    smsAllowance: null,
    remainingDataAllowanceKB: null,
    remainingDataAllowanceGB: 0.0,
    remainingVoiceAllowance: null,
    remainingSmsAllowance: null,
    usedDataDiscount: null,
    planHasDataDiscount: false,
    availableDataDiscount: null,
    usedAccountBalance: { value: 0.0, currency: 'GBP' },
    planIsDataOnly: false,
    availableAccountBalance: { value: 0.0, currency: 'GBP' },
    groups: {
      groupDiscountPercentage: 10,
      groupDiscountValue: { value: 0.0, currency: 'GBP' },
    },
    referrals: {
      referralCreditsUsed: false,
      referralCreditsAvailable: 0,
      referralDiscount: null,
    },
    voucher: {
      _sys_id: '4UYFuUjVo3ujOZbhxCdd3n',
      id: '4UYFuUjVo3ujOZbhxCdd3n',
      code: '15Mth6GB6Nov22NBOUpsell',
      title: '6GB for £6 NBO Black Friday Nov 22 Upsell',
      plan_card_heading: 'Switch now and get 6GB for £6',
      accordion_heading: '6GB for just £6 ',
      is_default: false,
      is_default_hero_banner: false,
      is_free_trial_voucher: false,
      valid_from: '2022-11-01T00:00+01:00',
      valid_to: '2022-12-05T23:59+01:00',
      applies_to: {
        _sys_id: '5Kk0iDpzNyX9fcqugpm0w2',
        id: 'SM_4GB_NDD',
        category: {
          _sys_id: '57qk7RvuVDnEiVHo0c8cvF',
          id: '57qk7RvuVDnEiVHo0c8cvF',
        },
        plan_color: {
          _sys_id: '2Sfln8Vw0cgdck7p3McyOX',
          id: '2Sfln8Vw0cgdck7p3McyOX',
        },
        plan_color_pale: {
          _sys_id: '1XWdtz8mVFJ62WDPpkBEjE',
          id: '1XWdtz8mVFJ62WDPpkBEjE',
        },
        name: '4GB',
        description: '4GB Data, Unlimited Text, Unlimited Voice',
        slug: '4gb-data',
      },
      discounted_price: 6,
      data_amount: 6,
      billing_line_items: [
        {
          _sys_id: '54ALluFpe2sMxhfpwE3Jwe',
          id: '6GB for just £6',
          label: 'Offer',
          value: '6',
          add_background_highlight: true,
        },
      ],
      offer_details:
        "Switch now to get an additional 2GB of data. That's a total of 6GB for just £6 (usually 4GB for £6) for up to 15 consecutive months, that gives you until January 2024 on this amazing offer.",
      offer_chip_text: 'SPECIAL OFFER ',
      roundel_type: 'Extra Data',
      terms_and_conditions_url:
        'https://cdn.smarty.co.uk/files/smarty-promo-15Mth6GB6Nov22NBOUpsell.pdf',
      show_countdown: false,
      promoPercentageDiscount: null,
      promoDiscount: null,
      promoAddonCode: '2GB_PROMO_DATA_GWG',
      promoAddonDescription: 'Promo extra data add-on (2GB)',
      promoAddonLimit: 2097152,
      promoAddonUnit: 'KB',
      promoValidFrom: '2022-11-18T09:46:00.000+0000',
      promoValidTo: '2022-12-05T00:00:00.000+0000',
      promoMonthsRemaining: 15,
    },
    planIsSocialTariff: false,
  },
]

export const mockPlans: Plan[] = [
  ...mockClassicPlans,
  ...mockDataDiscountPlans,
  ...mockDataOnlyPlans,
]
